import React from "react";
import styled from "styled-components";
import LoadingScreen from "../components/LoadingScreen";

const Container = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: white;
  background: rgba(255, 255, 255, 0.5);
  z-index: 10;
  display: flex;
  flex-direction: column;
`;

const GridLoadingOverlay = () => {
  return (
    <Container>
      <LoadingScreen />
    </Container>
  );
};

export default GridLoadingOverlay;
